import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextDescription, TextTitle, Text } from "components/Texts";

import Column from "components/Column";
import Dropdown from "components/Dropdown";
import Row from "components/Row";
import Section from "components/Section";
import _forEach from "lodash/forEach";
import _find from "lodash/find";
import _groupBy from "lodash/groupBy";
import _get from "lodash/get";
import colors from "styles/colors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import "styles/Trending.css";

import googleActions from "modules/google/actions";
import facebookActions from "modules/facebook/actions";
import googleSelectors from "modules/google/selectors";
import _, { filter, set } from "lodash";

import LoadingContainer from "components/LoadingContainer";
import { TrendingLineGraph, initGraphLabel, initGraphData } from "./TrendingLineGraph";

const TrendingGraph2 = ({ dataList, view, selectedViewValue }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [tooltip, setTooltip] = useState();
  const [metric, setMetric] = useState("all");
  const [type, setType] = useState("RCRM-step3");
  const [key, setKey] = useState("rcrm");
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [showLoadingContainer, setShowLoadingContainer] = useState(true);
  const [labelDate, setLabelDate] = useState([]);
  const [newDataList, setNewDataList] = useState([]);

  const [currentPipeline, setCurrentPipeline] = useState(0); // 0 is all, currentPipeline is index not id
  const [defaultPipeline, setDefaultPipeline] = useState(0);
  const [currentConversion, setCurrentConversion] = useState(0);
  const [currentConversionStatus, setCurrentConversionStatus] = useState("");
  const [conversionStatusLoading, setConversionStatusLoading] = useState(false);
  const businessPipelinesResult = useSelector((state) => googleSelectors.getBusinessPipelinesResult(state));
  const businessStepsResult = useSelector((state) => googleSelectors.getLeadStepsResult(state));
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const [totalConversions, setTotalConversions] = useState("");
  const [diffTotalConversions, setDiffTotalConversions] = useState("");
  const [pipelineDropdownList, setPipelineDropdownLists] = useState([]);
  const [hasDataListValue, setHasDataListValue] = useState(false);

  useEffect(() => {
    setHasDataListValue(false);

    if (dataList[metric]) {
      // Set total data
      setTotalConversions(dataList[metric].totalConversions);
      setDiffTotalConversions(dataList[metric].diffTotalConversions);

      const graphLabel = initGraphLabel(dataList, metric, selectedViewValue);
      setLabelDate(graphLabel);
    } else {
      setNewDataList([]);
      setTotalConversions(0);
      setDiffTotalConversions(0);
    }
  }, [dataList, metric, selectedViewValue]);

  useEffect(() => {
    if (labelDate.length > 0) {
      setHasDataListValue(false);
      const graphData = initGraphData(dataList, metric, labelDate, selectedViewValue);

      setNewDataList(graphData);
    }
  }, [labelDate]);

  useEffect(() => {
    checkDataListValue();
    setShowLoadingContainer(false);
  }, [newDataList]);

  const checkDataListValue = () => {
    newDataList.map((item) => {
      if (item.value && item.value > 0) {
        setHasDataListValue(true);
      }
    });
  };

  const handleOnSelectPipeline = (item, index) => {
    setCurrentPipeline(index);

    if (index === 0) {
      setMetric("all");
    }
  };

  const handleOnSelectConversion = (item, index) => {
    setCurrentConversion(index);
    setMetric(item.key);
  };

  const processPipelineData = (pipelineData, dataList) => {
    let activePipeline = [];
    let pipelineList = {};
    _forEach(businessPipelinesResult.data, (value, key) => {
      pipelineList[value.id] = {
        id: value.id,
        name: value.name,
        key: value.name,
        title: value.name,
        step: [],
      };
    });

    _forEach(dataList, (value, key) => {
      if (key.match(/RCRM-/)) {
        pipelineList[1].step.push(key);
      }
      let match = key.match(/RCRM\(Custom(\d+)\)-/);
      if (match !== null) {
        let pipeline_id = parseInt(match[1]) + 1;
        pipelineList[pipeline_id].step.push(key);
      }
    });

    _forEach(pipelineList, (value, key) => {
      if (value.step.length > 0) {
        activePipeline.push({
          id: value.id,
          name: value.name,
          key: value.name,
          title: value.name,
        });
      }
    });

    return { pipelineList, activePipeline };
  };

  // Get Pipelines
  useEffect(() => {
    async function fetchData() {
      setShowLoadingContainer(true);

      const pipelines = await dispatch(
        googleActions.getBusinessPipelines({
          token: rmpToken,
        }),
      );

      _forEach(pipelines.data, (value, key) => {
        if (value.default_pipeline === "Y") {
          setDefaultPipeline(0);
          setCurrentPipeline(0);
        }
      });

      setShowLoadingContainer(false);
    }

    fetchData();
  }, []);

  // Get Steps
  useEffect(() => {
    async function fetchData() {
      if (businessPipelinesResult.data.length > 0) {
        const allPipelineOption = [
          {
            title: t("__ads_performance_all_option"),
          },
        ];

        let { pipelineList, activePipeline } = processPipelineData(businessPipelinesResult.data, dataList);
        setPipelineDropdownLists(allPipelineOption.concat(activePipeline));

        if (currentPipeline !== 0) {
          setShowLoadingContainer(true);
          let pipeline_id = activePipeline[currentPipeline - 1].id;
          const steps = await dispatch(
            googleActions.getLeadSteps({
              token: rmpToken,
              lead_pipeline_id: pipeline_id,
              lang: sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en",
            }),
          );

          if (steps.result === 0 && steps.data.length > 0) {
            let conversionName = pipelineList[pipeline_id].step[0];
            setMetric(conversionName);
            setCurrentConversion(0);
          }
          setShowLoadingContainer(false);
        }
      }
    }
    fetchData();
  }, [businessPipelinesResult, currentPipeline]);

  useEffect(() => {
    if (businessStepsResult.leadPipelineInfo) {
      setCurrentConversionStatus(businessStepsResult.leadPipelineInfo.status_lead_conversion);
    }
  }, [businessStepsResult]);

  const RenderSteps = () => {
    let result = [];

    if (currentPipeline === 0) {
      result.push({
        title: t("__ads_performance_all_option"),
        key: "all",
      });
    } else {
      let key_dataList = Object.keys(dataList);
      _forEach(businessStepsResult.data, function (value, key) {
        if (key_dataList.indexOf(value.conversions_name) >= 0) {
          result.push({
            id: value.id,
            name: value.conversions_name,
            title: value.conversions_name,
            key: value.conversions_name,
          });
        }
      });
    }
    return result;
  };

  const isPositiveNumber = (data) => {
    var value = data;
    if (value === undefined || value === null || value === "" || value === "0" || value == 0 || value === "0.00") {
      data = "0.00";
    }
    if (typeof data !== "number") {
      value = data.replace(",", "");
      value = parseFloat(value);
    }
    return value > 0 ? "+" + data : data;
  };

  const adjustColumn = { display: "flex", gap: "5px", justifyContent: "flex-start" };
  const adjustDropdown = { flexGrow: 0, flexShrink: 1, flexBasis: "240px" };
  const adjustTotal = { flexGrow: 0, flexShrink: 1, flexBasis: "80px", marginLeft: "auto" };

  return (
    <RelativeContainer margin="0 0 2px">
      <Row margin="0px 0px 35px">
        <Column>
          <ColumnCard style={adjustColumn}>
            <div style={adjustDropdown} className="dropdown-card">
              <Text size="12px">{t("__fbads_dashboard_lead_pipeline")}</Text>
              <Dropdown
                items={pipelineDropdownList}
                onSelected={handleOnSelectPipeline}
                defaultIndex={defaultPipeline}
                minWidth="100%"
              />
            </div>
            <div style={adjustDropdown} className="dropdown-card">
              <Text size="12px">{t("__fbads_dashboard_lead_conversion_name")}</Text>
              <Dropdown
                items={RenderSteps() ?? []}
                onSelected={handleOnSelectConversion}
                defaultIndex={currentConversion}
                minWidth="100%"
                disabled={currentPipeline === 0}
              />
            </div>
            <div style={adjustTotal} className="dropdown-total">
              <Text size="12px" align="center">
                {t("__fbads_dashboard_lead_conversion_total")}
              </Text>
              <Text size="12px" align="center">
                <b>
                  {totalConversions === undefined ||
                  totalConversions === null ||
                  totalConversions === "" ||
                  totalConversions === "0" ||
                  totalConversions == 0 ||
                  totalConversions === "0.00"
                    ? "0.00"
                    : totalConversions}
                </b>
              </Text>
              {diffTotalConversions === "N/A" ? (
                <Text size="10px" align="center" color="#A8A8A8">
                  N/A
                </Text>
              ) : (
                <Text
                  size="10px"
                  align="center"
                  color={
                    diffTotalConversions && diffTotalConversions.indexOf("-") < 0
                      ? colors.positive
                      : diffTotalConversions && diffTotalConversions.indexOf("-") >= 0
                        ? colors.negative
                        : colors.positive
                  }
                >
                  {isPositiveNumber(diffTotalConversions)}%
                </Text>
              )}
            </div>
          </ColumnCard>
        </Column>
      </Row>
      <BarZone>
        {hasDataListValue === true > 0 ? (
          <>
            <TrendingLineGraph setTooltip={setTooltip} dataList={newDataList} metric={type} labels={labelDate} />
            {tooltip}
          </>
        ) : (
          <>
            <StyledEmptyContainer>
              <p>{t("__no_data")}</p>
            </StyledEmptyContainer>
          </>
        )}
      </BarZone>

      <LoadingContainer show={showLoadingContainer} />
    </RelativeContainer>
  );
};

export default TrendingGraph2;

const RelativeContainer = styled(Section)`
  position: relative;
`;

const BarZone = styled.div`
  height: 240px;
  position: relative;
`;
const StyledEmptyContainer = styled.div`
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const ManageColumn = styled(Column)`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 70px !important;
  margin-right: 5px !important;
`;

const ManageRow = styled(Row)`
  display: block !important;
`;

const ManageColumnForDropdown = styled(Column)`
  width: "100%";
  margin-right: 5px !important;

  @media screen and (max-width: 834px) {
    min-width: 100% !important;
    margin-bottom: 5px;
  }
`;

const ManageColumnWidth = styled(Column)`
  min-width: 100% !important;
`;

const ColumnCard = styled.div`
  @media screen and (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;

    .dropdown-card {
      flex: none !important;
      width: 100%;
      margin: 10px 0;
    }

    .dropdown-total {
      flex-basis: 20px !important;
      margin-left: 0px !important;
    }
  }
`;
